
import { useEffect, useState } from "react"
import styles from "./NewLogin.module.css"
import { get_school_login_page_detail, school_code_valid } from "../../Service/ApiServices";
import { toast } from "react-toastify";
import FormValidation from "../../GlobalComponent/Utils/FormValidation";
import FormInputChange from "../../GlobalComponent/Utils/FormInputChange";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Service/AuthService";
import { Button, Container } from "react-bootstrap";
import CommonInputField from "../../CommonFields/Input/CommonInputField";
import logindefaultimage from '../../Images/photo.png';

const LoginPage = () => {
const [schoolCodeData, setSchoolCodeData] = useState("");
  const [formdata, setFormData] = useState({
    username: "",
    password: "",
    school_code:""
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [screenError, setScreenError] = useState(false);
  const [Data, setData] = useState();
  const [SchoolLoading, setSchoolLoading] = useState(true);

  const navigate = useNavigate();
  const { login } = useAuth();
  const { school_code } = useParams();

  const handleInputChange = (e) => {
    FormInputChange(e, formdata, setFormData, false, errors, setErrors);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    console.log(formdata)
    if (FormValidation(formdata, {}, setErrors, [])) {
      setLoading(true);
      try {
        const response = await login(formdata);
        if (response.status) {
          FormDatClear();
          toast.success("Login successful!");
          navigate("/");
        } else {
          toast.error(response.message || "Login failed!");
          setErrors({ message: response.message });
        }
      } catch (error) {
        const message = error?.response?.data?.message || "An error occurred while logging in!";
        toast.error(message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.info("Username and password are required");
    }
  };

  const FormDatClear = () => {
    setFormData({
      username: "",
      password: "",
      school_code: "",
    });
  };

  // API call to validate school code
  useEffect(() => {
    if(school_code){
      setFormData(pre=>{
        return {...pre, school_code: school_code}
      })
    }
    school_code_valid({ school_code })
      .then((res) => {
        if (res.status) {
          setSchoolCodeData(res?.response?.data);
          setScreenError(false);
        } else {
          navigate('/login');
        }
      })
      .catch((error) => {
        console.error("Error fetching school data:", error);
        navigate('/login');  
      });
  }, [school_code, navigate]);

  // Fetch school login page details
  useEffect(() => {
    const abortController = new AbortController();
    if (school_code === schoolCodeData?.school_code) {
      get_school_login_page_detail(school_code, abortController.signal).then(res => {
        if (res.status) {
          setData(res?.response?.data);
        }
        setSchoolLoading(false);
      }).catch(() => {
        setSchoolLoading(false); // Hide loader on failure
      });
    }
    return () => {
      abortController.abort();
    };
  }, [school_code, schoolCodeData]);

  const image_url = process.env.REACT_APP_IMG_URL || 'https://sims.acstechconsulting.com/';


  return (
    <div className={styles.container}>
      {/* Left side - Hero section */}
      <div className={styles.heroSection}
      style={{
        backgroundImage:`url(${Data?.background_image ? `${image_url}${Data?.background_image}` : logindefaultimage})`
      }}
      >
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          {/* Logo */}
          <div className={styles.logo}>
             <img
  src={require("../../assets/brands.png")}
  alt="Profile"
    
 style={{maxWidth:"clamp(150px,4vw,220px",marginLeft:"-12px"}}
  
  // className={SidebarStyle.profile_image}
/>
          </div>

          {/* Main content */}
        <div className={styles.heroMainContent}>
  {Data?.description ?(
    <>
              <h4 className="mb-4" style={{ fontWeight: 'bold' }}>{Data?.title}</h4>
                        <p className="small mb-0 w-90%">
                          {Data?.description}
                        </p>
                        </>
  ):(
    <>
 <h1 className={styles.heroTitle}>
    Join <span className={styles.heroTitleHighlight}>100+</span> Schools that Trust Our Software to Simplify and Automate Their Campus Management
  </h1>
  {!Data?.description &&(
  <div className={styles.featureList}>
    <div className={styles.featureItem}>
      <svg className={styles.featureIcon} viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
      <span className={styles.featureText}>Online Fee Collection</span>
    </div>
    <div className={styles.featureItem}>
      <svg className={styles.featureIcon} viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
      <span className={styles.featureText}>Attendance & Reports</span>
    </div>
    <div className={styles.featureItem}>
      <svg className={styles.featureIcon} viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
      <span className={styles.featureText}>Parent & Student Portal</span>
    </div>
    <div className={styles.featureItem}>
      <svg className={styles.featureIcon} viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
      <span className={styles.featureText}>Powerful Admin Dashboard</span>
    </div>
  </div>
)}
  </>
  )}

 

</div>


          <div />
        </div>
          <footer
              className={styles.copyright}
            >
              <Container>
                <p>
                  &copy; 2026 GyanSansaar. All Rights
                  Reserved.
                </p>
              </Container>
            </footer>
      </div>
<div className={styles.rightSection}>

      {/* Right side - Login form */}
      <div className={styles.loginSection}>
        <div className={styles.loginContainer}>
         
           <div className="text-center">
                          <img
                            src={image_url + Data?.logo}
                            style={{ width: '120px', marginBottom: '1rem' }}
                            alt="logo"
                          />
                          <h4 className="mt-1 mb-5 pb-1" style={{ fontWeight: 'bold', color: '#333' }}>
                            Welcome to <span style={{ color: '#0a2647' }}>{Data?.name}</span>
                          </h4>
                        </div>

             <form onSubmit={handlesubmit}>
                                   <p className="text-muted">Please login to your account</p>
                                   <CommonInputField
                                     field="input"
                                     inputclass="loginInput-style"
                                     label="Username/Email/Phone"
                                     name="username"
                                     type="text"
                                     index="2"
                                     onChange={handleInputChange}
                                     value={formdata.username}
                                     valid={errors.username}
                                     placeholder="Enter Username..."
                                   />
                                   <CommonInputField
                                     inputclass="loginInput-style"
                                     field="input"
                                     type="password"
                                     label="Password*"
                                     name="password"
                                     placeholder="Enter Password..."
                                     index="3"
                                     onChange={handleInputChange}
                                     value={formdata.password}
                                     valid={errors.password}
                                   />
                                   <div className="d-flex justify-content-between align-items-center pt-1 mb-5 pb-1">
                                     <Button variant="dark" className="w-100 mt-2 p-2" type="submit" disabled={loading}>
                                       {loading ? "Please wait..." : "sign in"}
                                     </Button>
                                   </div>
         
                                   {/* Back To Home Button */}
                                   <div className="d-flex align-items-center justify-content-center pb-4">
                                     <button
                                       type="button"
                                       onClick={() => navigate('/login')}
                                       className="btn btn-outline-danger"
                                       style={{
                                         borderRadius: '20px',
                                         padding: '0.5rem 1.25rem',
                                         border: '2px solid #ff4d4d',
                                         color: '#ff4d4d',
                                         transition: 'all 0.3s ease',
                                       }}
                                       onMouseOver={(e) => (e.target.style.backgroundColor = 'rgba(202, 67, 67, 0.26)')}
                                       onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
                                     >
                                       Back To Home
                                     </button>
                                   </div>
                                 </form>

        
        </div>

       
      </div>
       <footer
              className={styles.copyright1}
            >
              <Container>
                <p>
                  &copy; 2026 GyanSansaar. All Rights
                  Reserved.
                </p>
              </Container>
            </footer>
      </div>
    </div>
  )
}

export default LoginPage
